<div id="booking-calendar" *ngIf="!loading">
  <!-- Timezones and Subjects -->
  <div class="flex-space-between">
    <div>
      <app-select-filterable
        [options]="timezones"
        label="timezones"
        [formControl]="timezoneCtrl"
      ></app-select-filterable>
    </div>
    <div></div>
  </div>
  <!-- Buttons -->
  <div class="flex-space-between">
    <div>
      <button
        mat-icon-button
        color="primary"
        (click)="calendarPrev()"
        [disabled]="disablePrevButton"
      >
        <mat-icon svgIcon="arrow-left"></mat-icon>
      </button>
      <button
        mat-icon-button
        color="primary"
        (click)="calendarNext()"
        [disabled]="disableNextButton"
      >
        <mat-icon svgIcon="arrow-right"></mat-icon>
      </button>
    </div>
    <div>{{ calendarTitle }}</div>
  </div>
  <full-calendar [options]="calendarOptions" #calendar> </full-calendar>
</div>
